slideToggle = (elem) => {
  elem.classList.toggle("hide");
};

document.querySelectorAll(".toggle").forEach((el) =>
  el.addEventListener("click", () => {
    let target = el.nextElementSibling;
    let icon = el.querySelector("svg");

    slideToggle(target);

    if (icon) {
      icon.classList.toggle("rotate-180");
    }
  }),
);
